import HubImageUploader from './hub-image-uploader/hub-image-uploader.vue'
import AddressAutocomplete from './address-autocomplete/address-autocomplete'
import Textarea from './textarea/textarea.vue'
import Status from './status/status'
import HubVideoUploader from './hub-video-uploader/hub-video-uploader.vue'
import OfferStatus from './offer-status/offer-status.vue'

export default {
  install(Vue, options) {
    Vue.component('hub-image-uploader', HubImageUploader)
    Vue.component('address-autocomplete', AddressAutocomplete)
    Vue.component('the-textarea', Textarea)
    Vue.component('status', Status)
    Vue.component('hub-video-uploader', HubVideoUploader)
    Vue.component('offerStatus', OfferStatus)
  },
}
